import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Lux Sensor Icon Style 01 - Light Mode (Material Symbol)
 * Lux sensors are always shown as "active" (amber) - they measure light
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:light_mode
 */
export const Style01_LightMode: React.FC<DeviceIconProps> = ({ 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = 'text-amber-500';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      light_mode
    </span>
  );
};

export default Style01_LightMode;
